import React from "react";
import styled from "styled-components";

export default ({ step, title }) => (
  <Navbar>
    <Typography>
      <Span>Step {step} of 3: </Span>
      {title}
    </Typography>
  </Navbar>
);

const Typography = styled.h4`
  font-weight: bold;
  color: #333333;
  margin: 0;
`;

const Span = styled.span`
  color: rgba(51, 51, 51, 0.4);
`;

const Navbar = styled.div`
  display: none;
  @media (max-width: 680px) {
    display: block;
    font-family: "CircularStd-Book", sans-serif;
    padding: 1rem 0;
    font-size: 1.1rem;
    text-align: center;
  }
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/Navbar.js